import { createSelector } from "reselect";

export const getStates = ({ states = {} } = {}) => states;

export const getStatesValues = createSelector(
  [getStates],
  ({ data = [] }) => data
);
